// extracted by mini-css-extract-plugin
module.exports = {"entry":"sidebar-menu-info-entry_entry__UrmOI","title":"sidebar-menu-info-entry_title__jZpxX"};